// extracted by mini-css-extract-plugin
export default {"container":"AK-z","dimension":"BK-z","dimensionLabels":"CK-z"};